module.exports = {
    "nested": {
      "protocol": {
        "options": {
          "optimize_for": "SPEED",
          "java_outer_classname": "ImInternalMessageVo",
          "java_package": "com.ctm.common.protobuf"
        },
        "nested": {
          "ImReqChat": {
            "fields": {
              "msgId": {
                "type": "string",
                "id": 1
              },
              "destType": {
                "type": "DestType",
                "id": 2
              },
              "fromId": {
                "type": "string",
                "id": 3
              },
              "fromUserType": {
                "type": "string",
                "id": 4
              },
              "fromRoleType": {
                "type": "string",
                "id": 5
              },
              "destId": {
                "type": "string",
                "id": 6
              },
              "destUserType": {
                "type": "string",
                "id": 7
              },
              "destRoleType": {
                "type": "string",
                "id": 8
              },
              "createTime": {
                "type": "int64",
                "id": 9
              },
              "msgBody": {
                "type": "string",
                "id": 10
              },
              "chatMsgType": {
                "type": "MsgType",
                "id": 11
              },
              "groupType": {
                "type": "string",
                "id": 12
              },
              "groupId": {
                "type": "int64",
                "id": 13
              },
              "destGroupItems": {
                "rule": "repeated",
                "type": "DestGroupUser",
                "id": 14
              }
            },
            "nested": {
              "DestType": {
                "values": {
                  "SINGLE": 0,
                  "GROUP": 1
                }
              },
              "MsgType": {
                "values": {
                  "TEXT": 0,
                  "FILE": 1,
                  "VOICE": 2,
                  "VIDEO": 3,
                  "IMAGE": 4,
                  "ADDUSER": 5
                }
              },
              "DestGroupUser": {
                "fields": {
                  "groupDestId": {
                    "type": "string",
                    "id": 1
                  },
                  "groupDestUserType": {
                    "type": "string",
                    "id": 2
                  },
                  "groupDestRoleType": {
                    "type": "string",
                    "id": 3
                  }
                }
              }
            }
          },
          "ImReqMessage": {
            "fields": {
              "version": {
                "type": "int32",
                "id": 1
              },
              "id": {
                "type": "string",
                "id": 2
              },
              "token": {
                "type": "string",
                "id": 3
              },
              "reqType": {
                "type": "ImReqType",
                "id": 4
              },
              "chat": {
                "type": "ImReqChat",
                "id": 5
              },
              "reqArriveTime": {
                "type": "string",
                "id": 6
              }
            },
            "nested": {
              "ImReqType": {
                "values": {
                  "GREET": 0,
                  "PING": 1,
                  "LOGIN": 2,
                  "SEND": 3,
                  "CLIENTACK": 4,
                  "OFFLINEMSG": 5,
                  "SENDNOACK": 6,
                  "ADDORREMOVEACK": 7,
                  "SYSNOTICEACK": 8
                }
              }
            }
          },
          "ImResMessage": {
            "fields": {
              "version": {
                "type": "int32",
                "id": 1
              },
              "id": {
                "type": "string",
                "id": 2
              },
              "from": {
                "type": "Module",
                "id": 3
              },
              "dest": {
                "type": "Module",
                "id": 4
              },
              "createTime": {
                "type": "string",
                "id": 5
              },
              "msgType": {
                "type": "MsgType",
                "id": 6
              },
              "chatType": {
                "type": "ChatType",
                "id": 7
              },
              "chatDestType": {
                "type": "ChatDestType",
                "id": 8
              },
              "fromId": {
                "type": "string",
                "id": 9
              },
              "fromUserType": {
                "type": "string",
                "id": 10
              },
              "fromRoleType": {
                "type": "string",
                "id": 11
              },
              "destId": {
                "type": "string",
                "id": 12
              },
              "destUserType": {
                "type": "string",
                "id": 13
              },
              "destRoleType": {
                "type": "string",
                "id": 14
              },
              "groupType": {
                "type": "string",
                "id": 15
              },
              "groupId": {
                "type": "string",
                "id": 16
              },
              "msgBody": {
                "type": "string",
                "id": 17
              },
              "clientMsgId": {
                "type": "string",
                "id": 18
              },
              "fromUserLoginType": {
                "type": "string",
                "id": 19
              },
              "destUserLoginType": {
                "type": "string",
                "id": 20
              }
            },
            "nested": {
              "Module": {
                "values": {
                  "CONNECTOR": 0,
                  "TRANSFER": 1,
                  "CLIENT": 2
                }
              },
              "ChatDestType": {
                "values": {
                  "SINGLE": 0,
                  "GROUP": 1
                }
              },
              "ChatType": {
                "values": {
                  "TEXT": 0,
                  "FILE": 1,
                  "VOICE": 2,
                  "VIDEO": 3,
                  "IMAGE": 4
                }
              },
              "MsgType": {
                "values": {
                  "GREET": 0,
                  "ACK": 1,
                  "ERROR": 2,
                  "CHAT": 3,
                  "LOGINOUT": 4,
                  "ADDUSER": 5,
                  "NOTIFICATION": 6,
                  "RECONECCT": 7,
                  "FORWARDCHAT": 8,
                  "REMOVEUSER": 9,
                  "SYSNOTICE": 10
                }
              }
            }
          },
          "ImResOffLineMessage": {
            "fields": {
              "offLineMessageItems": {
                "rule": "repeated",
                "type": "ImResMessage",
                "id": 1
              }
            }
          },
          "ImInternalMessage": {
            "fields": {
              "version": {
                "type": "int32",
                "id": 1
              },
              "offLineItem": {
                "rule": "repeated",
                "type": "DeleteCustomerServiceItem",
                "id": 2
              },
              "internalMsgType": {
                "type": "InternalMsgType",
                "id": 3
              }
            },
            "nested": {
              "InternalMsgType": {
                "values": {
                  "GREET": 0,
                  "CUSTOMER_SERVICE_UPDATE": 1,
                  "CUSTOMER_SERVICE_DISABLE": 2
                }
              },
              "DeleteCustomerServiceItem": {
                "fields": {
                  "phone": {
                    "type": "string",
                    "id": 1
                  },
                  "userId": {
                    "type": "string",
                    "id": 2
                  },
                  "roleType": {
                    "type": "string",
                    "id": 3
                  }
                }
              }
            }
          }
        }
      }
    }
  }